export default function jsonToFormData(json:any) {
    const formData = new FormData();

    for (const key in json) {
        formData.append(key, json[key]);

    }

    return formData;
}